// @flow

class SignProcessCompany {
  name: string;
  customerCompanyRol: string;
  phone: string;
  legalID: ?string;
  country: ?string;
  province: ?string;
  city: ?string;
  address: ?string;
  zipCode: ?string;

  static parseList(raw?: any): SignProcessCompany[] {
    let list: SignProcessCompany[] = [];
    if (raw && Array.isArray(raw)) {
      for (let item of raw) {
        const process: ?SignProcessCompany = SignProcessCompany.parse(item);
        if (process) {
          list.push(process);
        }
      }
    }
    return list;
  }

  static parse(raw: any): ?SignProcessCompany {
    if (raw) {
      let processCompany: SignProcessCompany = new SignProcessCompany();
      processCompany.name = raw.name;
      processCompany.customerCompanyRol = raw.customerCompanyRol;
      processCompany.phone = raw.phone;
      processCompany.legalID = raw.legalID;
      processCompany.country = raw.country;
      processCompany.province = raw.province;
      processCompany.city = raw.city;
      processCompany.address = raw.address;
      processCompany.zipCode = raw.zipCode;
      return processCompany;
    }
  }

  toDataMap(): any {
    return {
      name: this.name,
      customerCompanyRol: this.customerCompanyRol,
      phone: this.phone,
      legalID: this.legalID,
      country: this.country,
      province: this.province,
      city: this.city,
      address: this.address,
      zipCode: this.zipCode,
    };
  }
}

export default SignProcessCompany;
